import React from "react";
import s from "./ProjectItem.module.scss";
import { Link } from "react-router-dom";
import moment from "moment";
import { useDispatch } from "react-redux";
import { getApprovedProjectDetails } from "../../redux/ApplicationSlice";

const ProjectItem = ({ project, type }) => {
  const dispatch = useDispatch();
  return (
    <div className={s.projectItem}>
      <div className={s.img_wrapper}>
        <img
          src={
            type === "completedProject"
              ? project?.completed_project_images?.[0]?.file
              : project?.project_images?.[0]?.file
          }
          className={s.img}
        />
      </div>
      <div className={s.text}>
        <div className={s.title}>{project?.title}</div>
        <div className={s.header}>
          <div className={s.company}>{project?.company_name}</div>
          <div className={s.date}>
            {moment(project?.created_at).format("DD.MM.YYYY")}г.
          </div>
        </div>

        <div className={s.category}>{project?.project_field}</div>
        <div
          className={s.subtitle}
          dangerouslySetInnerHTML={{ __html: project?.body }}
        ></div>
      </div>
    </div>
  );
};

export default ProjectItem;
